import { AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';
  if (!value) return null;
  
  // Al menos 1 mayúscula
  if (!/[A-Z]/.test(value)) {
    return { passwordInvalid: 'La contraseña debe incluir al menos una letra mayúscula' };
  }

  // Al menos 1 minúscula
  if (!/[a-z]/.test(value)) {
    return { passwordInvalid: 'La contraseña debe incluir al menos una letra minúscula' };
  }

  // Al menos 1 dígito
  if (!/[0-9]/.test(value)) {
    return { passwordInvalid: 'La contraseña debe incluir al menos un número' };
  }

  // Longitud mínima de 8
  if (value.length < 8) {
    return { passwordInvalid: 'La contraseña debe tener al menos 8 caracteres' };
  }

  return null;
}


export function matchPasswords(passwordControlName: string, confirmControlName: string) {
    // Actualizado para cumplir con la firma ValidatorFn de Angular
    return (control: AbstractControl): ValidationErrors | null => {
      // Aseguramos que control es un FormGroup
      const formGroup = control as FormGroup;
      const passwordControl = formGroup.get(passwordControlName);
      const confirmControl = formGroup.get(confirmControlName);
  
      if (!passwordControl || !confirmControl) return null;
      
      if (confirmControl.errors && !confirmControl.errors['mustMatch']) {
        // si ya tiene otros errores, no los sobreescribimos
        return null;
      }
  
      // si las contraseñas no coinciden
      if (passwordControl.value !== confirmControl.value) {
        confirmControl.setErrors({ mustMatch: true });
        return { passwordsMismatch: true };
      } else {
        confirmControl.setErrors(null);
      }
  
      return null;
    };
  }